import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import useTokenInfo from "../../../hooks/useTokenInfo";
// import FlipNumbers from "react-flip-numbers";
import useStrictBackBlock from "../../../bridges/useStrictBackBlock";
import WizLoadingCircle from "../../../assets/components/WizLoadingCircle";
import checkOn from "../../../assets/icons/Select/check_checked.svg"
import checkOff from "../../../assets/icons/Select/check_unchecked.svg"

const EventMarketingAILoading = () => {
    const location = useLocation();
    const manualData = location.state;
    // const aiRec = manualData.aiRec;
    const storeBusinessNumber = manualData.store_business_number
    const navigate = useNavigate();
    const [stepStates, setStepStates] = useState(["idle", "idle", "idle"]);
    const {
        tokenInfo,
        fetchTokenInfo,
        deductToken,
    } = useTokenInfo();

    const didRun = useRef(false);

    useEffect(() => {
        localStorage.setItem("customMenu", manualData.customMenu)

        if (didRun.current) return;
        didRun.current = true;

        let timers = [];

        const sendGenerateRequest = async (timers, token) => {
            setStepStates(["loading", "idle", "idle"]);

            timers.push(setTimeout(() => setStepStates(["done", "loading", "idle"]), 1200));
            timers.push(setTimeout(() => setStepStates(["done", "done", "loading"]), 2200));

            const start = Date.now();
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/event/app`,
                    manualData,
                    {
                        headers: { "Content-Type": "application/json" },
                    }
                );
                const end = Date.now();
                const elapsed = end - start;
                const minVisible = 3000; // 최소 전체 로딩 시간
                const remaining = elapsed < minVisible ? minVisible - elapsed : 0;
                let tokenAll = null;
                if (response.status === 200) {
                    try {
                        tokenAll = await deductToken(token);
                    } catch (err) {
                        console.error("토큰 차감 실패: ", err)
                    }
                }

                timers.push(setTimeout(() => {
                    setStepStates(["done", "done", "done"]);
                }, remaining)); // ✅ 마지막 문구도 응답 직전 타이밍에 맞춰 띄움

                const data = [{ ...response.data, tokenAll }];

                timers.push(setTimeout(() => {
                    navigate(`/manual/marketing/ai/result/`, {
                        state: data,
                    });
                }, remaining + 800)); // ✅ 마지막 문구 잠깐 보여주고 이동

            } catch (error) {
                console.error("자동화 광고 생성 중 오류:", error);
                alert("이미지 생성에 실패하였습니다.");
                navigate(-2);
            }
        };

        const init = async () => {
            try {
                const token = await fetchTokenInfo();
                if (!Number.isFinite(token) || token <= 0) {
                    alert("이용 가능한 토큰이 없습니다. 결제 페이지로 이동합니다.");
                    return navigate("/myticket", { state: { storeBusinessNumber } });
                }

                await sendGenerateRequest(timers, token);
            } catch (err) {
                console.error("토큰 검사 중 오류:", err);
                alert("토큰 정보를 불러오는 중 오류가 발생했습니다.");
                navigate("/myticket", { state: { storeBusinessNumber } });
            }
        };

        init();
        return () => timers.forEach(clearTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



        
    const renderStep = (status, label) => {
        if (status === "loading") {
            return (
                <div className="flex items-center space-x-2 text-text-subtler text-b1">
                <img src={checkOff} alt="" />
                <span>{label} 분석 중</span>
                </div>
            );
        } else if (status === "done") {
            return (
                <div className="flex items-center space-x-2 text-text-primary text-b1">
                <img src={checkOn} alt="" />
                <span>{label} 분석 완료</span>
                </div>
            );
        }

        return (
          <div className="flex items-center space-x-2 text-text-subtler text-b1">
            <img src={checkOff} alt="" className="opacity-40" />
            <span>{label} 분석 예정</span>
          </div>
        );
    };

    useStrictBackBlock(true);

    return (
        <div className="fixed inset-0 bg-white z-50 flex flex-col justify-center items-center">
            {/* <div className="text-5xl text-purple-500 pb-8 animate-bounce">
                <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0z" />
                </svg>
            </div> */}
            <WizLoadingCircle />
            <p className="text-center text-t2 text-text-default pb-[24px] ">AI 이미지를 생성하고 있습니다.</p>
            <div className="text-center text-b1 text-text-subtle pb-[12px]">
                {renderStep(stepStates[0], "홍보 메뉴")}
                {renderStep(stepStates[1], "홍보 내용")}
                {renderStep(stepStates[2], "스타일")}
            </div>

            <div className="fixed bottom-[64px]">
                <p className="text-c2 text-text-subtle pb-[4px]">1개의 토큰을 사용하고 있어요</p>
                <div className="text-center text-c1 text-text-primary">
                {Number.isFinite(tokenInfo.total) ? (
                    <>
                        잔여 토큰{" "}
                        <div className="inline-flex">
                            {/* <FlipNumbers
                                height={16}
                                width={12}
                                color="#6B21A8"
                                background="transparent"
                                numbers={tokenInfo.total.toString()}
                                play
                                duration={1.3}
                                perspective={80}
                            /> */}
                            {tokenInfo.total.toString()}
                        </div>
                    </>
                ) : (
                    `(잔여 토큰 로딩중...)`
                )}
                </div>
            </div>
        </div>
    );
};

export default EventMarketingAILoading;
